import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { processSeoVariables } from '@iheartjane/utils';

export const description = (desc?: string) => {
  if (!desc) return {};
  return {
    content: desc,
    name: 'description',
  };
};

export const getMetaDescription = (
  customSEOPage?: Nullish<CustomSEOPage>,
  metaVariables: Record<string, string> = {}
) =>
  description(processSeoVariables(customSEOPage?.description, metaVariables));
